'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = void 0;
var _react = require('react');
var _provider = require('../../provider');
var useSelectWallet = function useSelectWallet() {
	var _useContext = (0, _react.useContext)(_provider.SeiWalletContext),
		setShowConnectModal = _useContext.setShowConnectModal;
	var openModal = function openModal() {
		return setShowConnectModal(true);
	};
	var closeModal = function closeModal() {
		return setShowConnectModal(false);
	};
	return {
		openModal: openModal,
		closeModal: closeModal
	};
};
var _default = (exports['default'] = useSelectWallet);
//# sourceMappingURL=useSelectWallet.js.map
